export interface IBytescaleURLMetadata {
  jobUrl: string;
  jobDocs: string;
  jobId: string;
  jobType: string;
  accountId: string;
  created: number;
  lastUpdated: number;
  status: string;
  summary: ISummary | undefined;
}

export interface ISummary {
  result: IResult;
}

export interface IResult {
  type: string;
  artifact: string;
  artifactUrl: string;
}

export interface IError {
  error: Error;
}

export interface Error {
  message: string;
  code: string;
  details: Details;
}

export interface Details {
  filePathNotFound: string;
}

export async function fetchMetadata(
  url: string,
): Promise<IBytescaleURLMetadata | IError> {
  try {
    const response = await fetch(url);
    return response.json() as Promise<IBytescaleURLMetadata | IError>;
  } catch {
    return {
      error: {
        message: "Failed to fetch metadata",
        code: "FETCH_ERROR",
        details: {
          filePathNotFound: url,
        },
      },
    };
  }
}

export async function fetchUrlMetadata(
  url: string,
): Promise<IBytescaleURLMetadata | IError> {
  const response = await fetchMetadata(url);

  if ("error" in response) {
    return response;
  }

  if (["Pending", "Running"].includes(response.status)) {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    const result = await fetchUrlMetadata(url);
    return result;
  }

  return response;
}
